import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

const OutletContext = createContext(null);

export function OutletProvider({ children }) {
  const { user } = useAuth();
  const [outlets, setOutlets] = useState([]);
  const [outletId, setOutletId] = useState(localStorage.getItem("pos_outlet") || "");

  const loadOutlets = useCallback(async () => {
    if (!user || user === false) return;
    try {
      const { data } = await api.get("/outlets", { params: { outlet_id: "" } });
      setOutlets(data);
      // Non-admins are auto-scoped to their assigned outlet
      if (user.role !== "admin" && user.outlet_id) {
        select(user.outlet_id);
      }
    } catch {}
  }, [user]); // eslint-disable-line

  useEffect(() => { loadOutlets(); }, [loadOutlets]);

  const select = (id) => {
    const prev = localStorage.getItem("pos_outlet") || "";
    setOutletId(id || "");
    if (id) localStorage.setItem("pos_outlet", id);
    else localStorage.removeItem("pos_outlet");
    // Reload current page so all GETs pick up the new scope cleanly
    if (prev !== (id || "")) {
      setTimeout(() => window.location.reload(), 100);
    }
  };

  const current = outlets.find((o) => o.id === outletId);
  const isAdmin = user && user !== false && user.role === "admin";

  return (
    <OutletContext.Provider value={{ outlets, outletId, select, current, isAdmin, reload: loadOutlets }}>
      {children}
    </OutletContext.Provider>
  );
}

export const useOutlet = () => useContext(OutletContext);
